import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Layout from '../Layout/index';
import MainWrapper from './MainWrapper';
import LogIn from '../LogIn/index';
import FunctionalityPanel from '../FunctionalityPanel/index';
import Subject from '../Subject/index';
import SubjectFormHandler from '../Subject/components/SubjectFormHandler';
import Room from '../Room/index';
import Shift from '../Shift/index';
import ShiftFormHandler from '../Shift/components/FormHandler';
import MemoTemplate from '../MemoTemplate/index';
import AnalysisItem from '../AnalysisItem/index';
import AnalysisItemFormHandler from '../AnalysisItem/components/FormHandler';
import EvaluationWay from '../EvaluationWay/index';
import EvaluationWayFormHandler from '../EvaluationWay/components/FormHandler';
import EvaluationCrieria from '../EvaluationCriteria/index';
import EvaluationCriteriaFormHandler from '../EvaluationCriteria/components/FormHandler';
import TeachingTechnique from '../TeachingTechnique/index';
import TeachingTechniqueFormHandler from '../TeachingTechnique/components/FormHandler';
import EducationStage from '../EducationStage/index';
import SchoolGradeForm from '../SchoolGrade/index';
import Employee from '../Employee/index';
import SchoolClass from '../SchoolClass/index';
import SchoolClassFormHandler from '../SchoolClass/components/FormHandler';
import Responsible from '../Responsible/index';
import ResponsibleFormHandler from '../Responsible/FormHandler';
import Menu from '../Menu/index';
import FormHandler from '../Menu/Components/FormHandler';
import SchoolTerm from '../SchoolTerm/index';
import SchoolFormHandler from '../SchoolTerm/components/FormHandler';
import Student from '../Student/index';
import StudentFormHandler from '../Student/components/FormHandler';
import Communication from '../Communication/index';
import CommunicationFormHandler from '../Communication/components/FormHandler';
import QuestionDatabase from '../QuestionDatabase/index';
import QuestionDatabaseFormHandler from '../QuestionDatabase/components/FormHandler';
import ReceivingCategory from '../ReceivingCategory/index';
import ReceivingCatFormHandler from '../ReceivingCategory/components/FormHandler';
import WeightMeasure from '../WeightMeasure/index';
import WeightMeasureFormHandler from '../WeightMeasure/components/FormHandler';
import Product from '../Product/index';
import ProductFormHandler from '../Product/components/FormHandler';
import Account from '../Account/index';
import AccountFormHandler from '../Account/components/FormHandler';
import PeriodicAnalysis from '../PeriodicAnalysis/index';
import PeriodicAnalysisFormHandler from '../PeriodicAnalysis/components/FormHandler';
import Calendar from '../Calendar/index';
import SmartGo from '../SmartGo/index';
import Medication from '../Medication/index';
import MedicationFormHandler from '../Medication/components/FormHandler';
import MedicationApplication from '../MedicationApplication/index';
import AccessProfileFormHandler from '../AccessProfile/components/FormHandler';
import AccessProfile from '../AccessProfile/index';
import ChangeMyPass from '../ChangeMyPass/index';
import ChangePassResponsible from '../ChangePassResponsible/components/FormHandler';
import CommunicationChannelFormHandler from '../CommunicationChannel/components/FormHandler';
import CommunicationChannel from '../CommunicationChannel/index';
import ProtectedRoute from './ProtectedRoute';
import PrivacyPolicy from '../Politics/PrivacyPolicy';
import AppointmentFormHandler from '../Appointment/components/FormHandler';
import SchoolData from '../SchoolData';
import Appointment from '../Appointment/index';
import AccountsReceivableAndPayable from '../AccountsReceivableAndPayable/index';
import AccountsReceivableAndPayableFormHandler from '../AccountsReceivableAndPayable/components/FormHandler';
import Contract from '../Contract/index';
import ContractFormHandler from '../Contract/components/FormHandler';
import Chat from '../Chat/index';
import Dashboard from '../Dashboard/index';
import Vaccination from '../Vaccination/index';
import TabletItems from '../TabletItems/index';
import ContractTypes from '../ContractTypes/index';
import ContractTypesForm from '../ContractTypes/components/FormHandler';
import UploadCentral from '../UploadCentral/index';
import ReportCentral from '../ReportCentral/index';
import ReportParametersFormHandler from '../ReportParameters/components/FormHandler';
import Course from '../Course/index';
import CourseFormHandler from '../Course/components/FormHandler';
import ClassDiaryFormHandler from '../ClassDiary/components/FormHandler';
import AcademicCalendar from '../AcademicCalendar/index';
import AcademicCalendarFormHandler from '../AcademicCalendar/components/FormHandler';
import RecordOccurrencesFormHandler from '../RecordOccurrences/components/FormHandler';
import RecordOccurrences from '../RecordOccurrences/index';
import MemoTemplateFormHandler from '../MemoTemplate/components/FormHandler';
import ClassPlanFormHandler from '../ClassPlan/components/FormHandler';
import ClassPlan from '../ClassPlan/index';
import TeachersRoom from '../TeachersRoom/index';
import ClassDiary from '../ClassDiary';
import CycleClosureFormHandler from '../CycleClosing/components/FormHandler';
import CycleClosure from '../CycleClosing';
import ReportCard from '../ReportCard';
import ReportCardHandler from '../ReportCard/components/ReportCardHandler';
import Camera from '../Camera';
import CameraFormHandler from '../Camera/components/FormHandler';
import Audit from '../Audit/index';
import {
  PAYABLE,
  RECEIVABLE,
  TEMPLATE_TYPE_COMU,
  TEMPLATE_TYPE_OCCU,
} from '../../shared/utils/constants';
import EmployeeFormHandler from '../Employee/components/FormHandler';
import RoomFormHandler from '../Room/components/FormHandler';

const Pages = () => (
  <Switch>
    <ProtectedRoute
      path="/minime/controlpanel"
      component={FunctionalityPanel}
    />
    <ProtectedRoute
      path="/minime/disciplina/mnt/:id"
      component={SubjectFormHandler}
    />
    <ProtectedRoute path="/minime/disciplina" component={Subject} />
    <ProtectedRoute path="/minime/sala/mnt/:id" component={RoomFormHandler} />
    <ProtectedRoute path="/minime/sala" component={Room} />
    <ProtectedRoute path="/minime/turno/mnt/:id" component={ShiftFormHandler} />
    <ProtectedRoute path="/minime/turno" component={Shift} />
    <ProtectedRoute
      path="/minime/template-:type/mnt/:id"
      component={MemoTemplateFormHandler}
    />
    <ProtectedRoute
      path="/minime/template-comunicado"
      component={(props) => (
        <MemoTemplate {...props} type={TEMPLATE_TYPE_COMU} />
      )}
    />
    <ProtectedRoute
      path="/minime/template-ocorrencia"
      component={(props) => (
        <MemoTemplate {...props} type={TEMPLATE_TYPE_OCCU} />
      )}
    />
    <ProtectedRoute
      path="/minime/item-analise/mnt/:id"
      component={AnalysisItemFormHandler}
    />
    <ProtectedRoute path="/minime/item-analise" component={AnalysisItem} />
    <ProtectedRoute
      path="/minime/instrumento-avaliacao/mnt/:id"
      component={EvaluationWayFormHandler}
    />
    <ProtectedRoute
      path="/minime/instrumento-avaliacao"
      component={EvaluationWay}
    />
    <ProtectedRoute
      path="/minime/criterio-avaliacao/mnt/:id"
      component={EvaluationCriteriaFormHandler}
    />
    <ProtectedRoute
      path="/minime/criterio-avaliacao"
      component={EvaluationCrieria}
    />
    <ProtectedRoute
      path="/minime/tecnica-ensino/mnt/:id"
      component={TeachingTechniqueFormHandler}
    />
    <ProtectedRoute
      path="/minime/tecnica-ensino"
      component={TeachingTechnique}
    />
    <ProtectedRoute path="/minime/ensino" component={EducationStage} />
    <ProtectedRoute path="/minime/serie" component={SchoolGradeForm} />
    <ProtectedRoute
      path="/minime/funcionario/mnt/:id"
      component={EmployeeFormHandler}
    />
    <ProtectedRoute path="/minime/funcionario" component={Employee} />
    <ProtectedRoute
      path="/minime/turma/mnt/:id"
      component={SchoolClassFormHandler}
    />
    <ProtectedRoute path="/minime/turma" component={SchoolClass} />
    <ProtectedRoute
      path="/minime/responsavel/mnt/:email"
      component={ResponsibleFormHandler}
    />
    <ProtectedRoute path="/minime/responsavel" component={Responsible} />
    <ProtectedRoute path="/minime/cardapio/mnt/:id" component={FormHandler} />
    <ProtectedRoute path="/minime/cardapio" component={Menu} />
    <ProtectedRoute
      path="/minime/periodo-letivo/mnt/:id"
      component={SchoolFormHandler}
    />
    <ProtectedRoute path="/minime/periodo-letivo" component={SchoolTerm} />
    <ProtectedRoute
      path="/minime/aluno/mnt/:id"
      component={StudentFormHandler}
    />
    <ProtectedRoute path="/minime/aluno" component={Student} />
    <ProtectedRoute
      path="/minime/postagem/mnt/:type/:id"
      component={CommunicationFormHandler}
    />
    <ProtectedRoute path="/minime/postagem" component={Communication} />
    <ProtectedRoute path="/minime/uploadcentral" component={UploadCentral} />
    <ProtectedRoute
      path="/minime/banco-questoes/mnt/:id"
      component={QuestionDatabaseFormHandler}
    />
    <ProtectedRoute
      path="/minime/banco-questoes"
      component={QuestionDatabase}
    />
    <ProtectedRoute
      path="/minime/categoria-recebimento/mnt/:id"
      component={ReceivingCatFormHandler}
    />

    <ProtectedRoute
      path="/minime/categoria-recebimento"
      component={ReceivingCategory}
    />
    <ProtectedRoute
      path="/minime/produto/mnt/:id"
      component={ProductFormHandler}
    />
    <ProtectedRoute path="/minime/produto" component={Product} />
    <ProtectedRoute
      path="/minime/conta/mnt/:id"
      component={AccountFormHandler}
    />
    <ProtectedRoute path="/minime/conta" component={Account} />
    <ProtectedRoute
      path="/minime/analise/mnt/:id"
      component={PeriodicAnalysisFormHandler}
    />
    <ProtectedRoute path="/minime/analise" component={PeriodicAnalysis} />
    <ProtectedRoute path="/minime/calendario" component={Calendar} />
    <ProtectedRoute path="/minime/smartgo" component={SmartGo} />
    <ProtectedRoute
      path="/minime/peso-medida/mnt/:id"
      component={WeightMeasureFormHandler}
    />
    <ProtectedRoute path="/minime/peso-medida" component={WeightMeasure} />
    <ProtectedRoute
      path="/minime/medicacao/mnt/:id"
      component={MedicationFormHandler}
    />
    <ProtectedRoute path="/minime/medicacao" component={Medication} />
    <ProtectedRoute
      path="/minime/aplicacao-medicamento"
      component={MedicationApplication}
    />
    <ProtectedRoute
      path="/minime/acesso/mnt/:id"
      component={AccessProfileFormHandler}
    />
    <ProtectedRoute path="/minime/acesso" component={AccessProfile} />
    <ProtectedRoute path="/minime/minha-senha" component={ChangeMyPass} />
    <ProtectedRoute
      path="/minime/senha-responsavel"
      component={ChangePassResponsible}
    />
    <ProtectedRoute
      path="/minime/canal-comunicacao/mnt/:id"
      component={CommunicationChannelFormHandler}
    />
    <ProtectedRoute
      path="/minime/canal-comunicacao"
      component={CommunicationChannel}
    />
    <ProtectedRoute
      path="/minime/apontamento/mnt/:id"
      component={AppointmentFormHandler}
    />
    <ProtectedRoute path="/minime/dados-escola" component={SchoolData} />
    <ProtectedRoute path="/minime/apontamento" component={Appointment} />
    <ProtectedRoute
      path="/minime/conta-:type/mnt/:id"
      component={AccountsReceivableAndPayableFormHandler}
    />
    <ProtectedRoute
      path="/minime/conta-receber"
      component={(props) => (
        <AccountsReceivableAndPayable {...props} type={RECEIVABLE} />
      )}
    />
    <ProtectedRoute
      path="/minime/conta-pagar"
      component={(props) => (
        <AccountsReceivableAndPayable {...props} type={PAYABLE} />
      )}
    />
    <ProtectedRoute
      path="/minime/contrato/mnt/:id"
      component={ContractFormHandler}
    />
    <ProtectedRoute path="/minime/contrato" component={Contract} />
    <ProtectedRoute path="/minime/dashboard" component={Dashboard} />
    <ProtectedRoute path="/minime/vacinacao" component={Vaccination} />
    <ProtectedRoute path="/minime/chat" component={Chat} />
    <ProtectedRoute
      path="/minime/acesso/mnt/:id"
      component={AccessProfileFormHandler}
    />
    <ProtectedRoute path="/minime/acesso" component={AccessProfile} />
    <ProtectedRoute
      path="/minime/configuracao-tablet"
      component={TabletItems}
    />
    <ProtectedRoute
      path="/minime/tipo-contrato/mnt/:id"
      component={ContractTypesForm}
    />
    <ProtectedRoute path="/minime/tipo-contrato" component={ContractTypes} />
    <ProtectedRoute
      path="/minime/relatorio/:name/:type"
      component={ReportParametersFormHandler}
    />
    <ProtectedRoute path="/minime/relatorio" component={ReportCentral} />
    <ProtectedRoute
      path="/minime/calendario-academico/mnt/:id"
      component={AcademicCalendarFormHandler}
    />
    <ProtectedRoute
      path="/minime/calendario-academico"
      component={AcademicCalendar}
    />
    <ProtectedRoute
      path="/minime/curso/mnt/:id"
      component={CourseFormHandler}
    />
    <ProtectedRoute path="/minime/curso" component={Course} />
    <ProtectedRoute
      path="/minime/diario-classe/mnt/:id"
      component={ClassDiaryFormHandler}
    />
    <ProtectedRoute path="/minime/diario-classe" component={ClassDiary} />
    <ProtectedRoute
      path="/minime/ocorrencia/mnt/:id"
      component={RecordOccurrencesFormHandler}
    />
    <ProtectedRoute path="/minime/ocorrencia" component={RecordOccurrences} />
    <ProtectedRoute
      path="/minime/plano-aula/mnt/:id"
      component={ClassPlanFormHandler}
    />
    <ProtectedRoute path="/minime/plano-aula" component={ClassPlan} />
    <ProtectedRoute path="/minime/sala-professor" component={TeachersRoom} />
    <ProtectedRoute
      path="/minime/consolidacao-ciclo/mnt/:id"
      component={CycleClosureFormHandler}
    />
    <ProtectedRoute
      path="/minime/consolidacao-ciclo"
      component={CycleClosure}
    />
    <ProtectedRoute
      path="/minime/fechamento-ciclo/mnt/:id"
      component={ReportCardHandler}
    />
    <ProtectedRoute path="/minime/fechamento-ciclo" component={ReportCard} />
    <ProtectedRoute
      path="/minime/configuracao-camera/mnt/:id"
      component={CameraFormHandler}
    />
    <ProtectedRoute path="/minime/configuracao-camera" component={Camera} />
    <ProtectedRoute path="/minime/auditoria" component={Audit} />
  </Switch>
);

const wrappedRoutes = () => (
  <div>
    <Layout />
    <div className="container__wrap">
      <ProtectedRoute path="/minime" component={Pages} />
    </div>
  </div>
);

const Router = () => (
  <MainWrapper>
    <main>
      <Switch>
        <Route exact path="/minime/politica.html" component={PrivacyPolicy} />
        <Route exact path="/minime" component={LogIn} />
        <Route exact path="/" component={LogIn} />
        <ProtectedRoute path="/minime" component={wrappedRoutes} />
        <Route path="*" component={() => <h1>Page not found</h1>} />
      </Switch>
    </main>
  </MainWrapper>
);

export default Router;
